import type { FaqItem } from "@/components/feature/FaqAccordion";

/**
 * Answers the questions people ask most before booking their first farm
 * experience — especially "is agri-tourism really for me?". The same data
 * powers the FAQPage structured data on the experiences listing.
 */
export const experiencesFaqs: FaqItem[] = [
  {
    q: "Is agri-tourism right for me?",
    a: "Agri-tourism is simply spending time on a real, working farm — walking the fields, meeting the farmer, taking part in the season's work and sharing a home-cooked meal. If you enjoy nature, food or learning how things grow, it is very likely right for you. You do not need any farming background, and everything is led at a comfortable pace by the farmer host.",
  },
  {
    q: "I have never been on a farm before — will I enjoy it?",
    a: "Absolutely. Most of our visitors are first-timers from cities and towns who have never stepped into a field. The experience is guided from start to finish, so you always know what to do, and you can join in as much or as little as you like.",
  },
  {
    q: "Which experience should I choose?",
    a: "Pick by who you are travelling with and what you are curious about. Families and young children love the Family Farm Experiences, food lovers enjoy Soil to Plate, schools choose the Educational Farm Visits and corporate teams go for the Rural Corporate Experiences. If you are unsure, browse the filters above or send us a note and we will match you.",
  },
  {
    q: "Is it suitable for children and older visitors?",
    a: "Yes. Many of our experiences are designed for families and children, and the walking is gentle and mostly on flat ground. Activities are always adjusted to the group, so everyone from young children to grandparents can take part comfortably.",
  },
  {
    q: "How far in advance should I book?",
    a: "We recommend booking at least 3–5 days ahead so the farmer can plan around the season and the farm's work. During the cooler months from October to February dates fill up faster, so booking a week or two ahead is wise.",
  },
  {
    q: "What should I wear and bring?",
    a: "Wear comfortable clothes you don't mind getting a little muddy and closed shoes or sturdy sandals. Carry a change of clothes, a hat, sunscreen and a water bottle. We provide basic farm gloves and drinking water on site.",
  },
];